import { OskBuySubscriptionFormComponent } from '../osk-buy-subscription-form/osk-buy-subscription-form.component';
import { MyOskSubscriptionsService } from '../../../../api/api-services/my-osk-subscriptions.service';
import { IInitialisedPaymentLinkVm } from '../../../../api/initialised-payment-link-vm.model';
import { IMyOskSubscriptonsVm } from '../../../../api/my-osk-subscriptons-vm.model';
import { centerDynamicModalConfig } from '../../../shared/helpers/modal.config';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { OskSubscriptionsService } from '../osk-subscriptions.service';
import { eModalRoles } from '../../../shared/models/modals';
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-osk-payment-cancel',
  templateUrl: './osk-payment-cancel.component.html',
  styleUrl: './osk-payment-cancel.component.scss',
})
export class OskPaymentCancelComponent implements OnInit {
  private _primengDialogService = inject(DialogService);
  private _myOskSubscriptionsService = inject(MyOskSubscriptionsService);
  private _oskSubscriptionsService = inject(OskSubscriptionsService);

  public loading: boolean = false;

  private _router = inject(Router);
  private ref: DynamicDialogRef | undefined;

  ngOnInit(): void {
    if (!localStorage.getItem('selectedSubscriptions')) {
      this._router.navigate(['/osk-subscriptions/list']);
    }
  }

  goToBuySubscriptionsModal(selectedSubscriptionGuid: string | null): void {
    this.loading = true; // Show a loading indicator or disable button while loading
    this._myOskSubscriptionsService.get().subscribe({
      next: (data: IMyOskSubscriptonsVm[]) => {
        this.loading = false;
        if (data.length > 0) {
          this.openBuySubscriptionModal(selectedSubscriptionGuid, data);
        } else {
          console.error('Subscriptions are not available');
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Error fetching subscriptions data:', err);
      },
    });
  }

  openBuySubscriptionModal(
    selectedSubscriptionGuid: string | null,
    subscriptionPlans: IMyOskSubscriptonsVm[]
  ) {
    this.ref = this._primengDialogService.open(
      OskBuySubscriptionFormComponent,
      {
        ...centerDynamicModalConfig,
        data: {
          subscriptionPlans,
          selectedSubscriptionGuid,
        },
      }
    );

    this.ref.onClose.subscribe(
      (res: {
        status: eModalRoles;
        link: IInitialisedPaymentLinkVm | null;
      }) => {
        if (res.status === eModalRoles.SUCCESS) {
          if (res.link?.sessionUrl) {
            window.open(res.link?.sessionUrl, '_self');
          }
        }
      }
    );
  }

  renewOskSubscriptionsTransaction(): void {
    this.loading = true;

    this._oskSubscriptionsService.oskSetSubscriptionPayment$().subscribe({
      next: (res: IInitialisedPaymentLinkVm) => {
        this.loading = false;
        if (res?.sessionUrl) {
          window.open(res?.sessionUrl, '_self');
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('My OSK platform subscription order error:', err);
      },
    });
  }
}
